<template>
  <transition name="slide">
    <div v-show="visible" class="loading-mask" @touchmove.stop.prevent="$emit('on-touchmove')">
      <spinner color="rgb(255,95,22)" :text="text"></spinner>
    </div>
  </transition>
</template>

<script>
  import spinner from './spinner.vue'

  export default {
    name: 'loading',
    props: {
      text: {
        type: String,
        default: "正在加载中..."
      }
    },
    data() {
      return {
        visible: false
      }
    },
    components: {
      spinner,
    }
  }
</script>

<style lang="less">
  .loading-mask {
    background: #ffffff;
    z-index: 100;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>

